import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toolbox-talks-templates-importer',
  templateUrl: './toolbox-talks-templates-importer.component.html',
  styleUrls: ['./toolbox-talks-templates-importer.component.css']
})
export class ToolboxTalksTemplatesImporterComponent implements OnInit {

  constructor() { }

  ngOnInit() {}
}
